import { useTranslation } from 'react-i18next';
import type { OpenWorkRecordInfo } from '../../types';

/**
 * FIX-OPENREC (D-63) — one open work record with "חידוש" and "סיום ותיעוד". The same row
 * in the timers panel (GlobalTimer) and in Home's header, so both act the same way.
 */
export default function OpenRecordRow({ rec, busy, onResume, onFinish, className }: {
  rec: OpenWorkRecordInfo;
  busy: boolean;
  onResume: (rec: OpenWorkRecordInfo) => void;
  onFinish: (rec: OpenWorkRecordInfo) => void;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={className ?? 'flex items-center gap-2 px-2 py-1'} data-testid="open-record-row">
      <span className="text-xs text-text truncate flex-1">{rec.ticket_title}</span>
      <button
        type="button"
        onClick={() => onResume(rec)}
        disabled={busy}
        className="text-xs font-medium text-accent-text hover:underline"
      >
        {t('timeTasks.timers.resume')}
      </button>
      <button
        type="button"
        onClick={() => onFinish(rec)}
        className="text-xs font-medium text-success-700 hover:underline"
      >
        {t('timeTasks.timers.finish')}
      </button>
    </div>
  );
}
